import {Divider} from "antd";

export const releaseVersion = `2.0.22d`
export const releaseNotes = (
    <>
        <h1>v2.0.22d</h1>
        Release: 05.11.2026

        <h2>Neu</h2>
        <ul>
            <li>Auge-Icon in ToDos öffnet das betroffene Geräte / den betroffenen Kunden</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>{'Im MG-Excel-Export werden in der Mappe "Alter < 16J" die gefilterten Rohdaten angezeigt.'}</li>
            <li>Verbesserte Ansicht für die Erstellung von ToDos</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.22c</h1>
        Release: 27.10.2026 16:00 Uhr

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers, welcher manuelle Eingaben in der Vorberechnung inkludiert hat. </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.22b2</h1>
        Release: 27.10.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers, welcher die Erzeugung von ToDos verhindert hat. </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

         <h1>v2.0.22b</h1>
        Release: 24.10.2026

        <h2>Neu</h2>
        <ul>
            <li>Freitext ToDos: Es können ToDos mit beliebigem Text erstellt und Kunden bzw. Geräten zugewiesen werden.</li>
        </ul>

        <h2>Update</h2>
        <ul>
            <li>Die Anzahl offener Todos wird im Menü angezeigt</li>
            <li>Ergänzung der Spalte "Verfahren" im Mapping für CT Guerbet</li>
            <li>Anpassung des Standardeinstellungen im Mapping für CT Guerbet</li>
            <li>Behebung eines Fehlers, welcher in XR Domako 3rdParty zu fehlendem Patientenalter führt.</li>
            <li>Behebung des fehlenden Phantoms in CT DoseM. Phantom wird basierend auf der Spalte U "Phantom" ermittelt.</li>
            <li>Behebung eines Fehlers, welcher die Vorberechnung von Werten verhindert, wenn die hochgeladenen Daten über zwei Jahre verteilt sind.</li>
            <li>ToDos Berichte zu erstellen werden nur noch erzeugt, wenn vorher eine Aufgabe existiert die entsprechenden Daten hochzuladen.</li>
            <li>Kunden- und Geräteliste können nach dem ToDo-Status gefiltert und sortiert werden. </li>
        </ul>
        <Divider style={{marginTop: 96}}/>


        <h1>v2.0.22a</h1>
        Release: 03.09.2026

        <h2>Update</h2>
        <ul>
            <li>Behebung eines Fehler, welcher bei großen TQM-Dateien zu vertauschten Spalten führt</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.22</h1>
        Release: 02.09.2026

        <h2>Updates</h2>
        <ul>
            <li>Der Excel-Export enthält jetzt die Rohdaten, Daten mit Hilfsscans und die gefilterten Daten in drei separaten Mappen</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.21d</h1>
        Release: 02.09.2026

        <h2>Updates</h2>
        <ul>
            <li>Korrekturen bei der Erzeugung regelmäßiger ToDos</li>
            <li>Umstellung der HeadNames zur Phantomprüfung auf flexible Regex-Filter</li>
            <li>Ergänzung des Phantoms im Ashvins-Import für CT</li>
            <li>Erweiterung der RegexFilter um Vergleichsoperatoren für Zahlenwerte</li>
            <li>Umstellung des Patientenalter auf PATIENT_AGE_DAYS in TQM-Importen</li>
            <li>Rekonstruktionsdaten werden in Guerbet-Importen für CT und MG jetzt ignoriert</li>
            <li>Der Gesamt-DFP wird in ClinicalPACS-Importen für RF jetzt als solcher und nicht mehr als eigene Untersuchung eingelesen</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.21c</h1>
        Release: 28.08.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers, welcher zu fehlenden Zeilen in der Tabelle 4.1 im CT-Jahresbericht führte.</li>
            <li>Abfangen von Berechnungsfehlern (Teilen durch 0) im Monatsbericht MG, wenn Patienten das Gewicht 0 haben.</li>
            <li>Änderung des Trennzeichens von DRW in Tabelle 4.1 auf "/"</li>
            <li>Reduktion der Löschung von Vorberechnungen bei Filteranpassungen.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.21b</h1>
        Release: 07.08.2026

        <h2>Updates</h2>
        <ul>
            <li>Korrektur der Erstellung der ToDos für den Vormonat</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.21a</h1>
        Release: 06.08.2026

        <h2>Updates</h2>
        <ul>
            <li>Korrektur der Erstellung der Excel Mappe für Lungenkrebsscreenings</li>
            <li>Die Liste der Geräte wird nach dem Hochladen von Daten aktualisiert</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.21</h1>
        Release: 05.08.2026

        <h2>Neu</h2>
        <ul>
            <li>To-Do Listen mit monatlichen Aufgaben Daten hochzuladen und Berichte zu erstellen.</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Entfernung der Aufteilung nach Körperteil in der Tabelle 4.1 in Monats- und Jahresberichten.</li>
            <li>Ergänzung eines Hinweises zur Einheitsumrechnung in Monats- und Jahresberichten.</li>
            <li>Ergänzung einer Mappe für Lungenkrebsscreenings (DRW = 1,3) im Excel Export für CTs.</li>
            <li>Behebung einer Abhängigkeit, welche zu Ladezeitüberschreitungen bei der Erstellung von Berichtstexten führt.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.20a</h1>
        Release: 28.07.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers, bei welchem für MG Dose&Care, MG Guerbet und MG TQM keine Referenztwerte zugeordnet wurden, wenn in den Rohdaten die Lateralität angegeben ist.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.20</h1>
        Release: 22.07.2026

        <h2>Neu</h2>
        <ul>
            <li>Export für E-Mail-Adressen aufgeteilt nach Rolle des Kontaktes hinzugefügt.</li>

        </ul>
        <Divider style={{marginTop: 96}}/>
        
        <h1>v2.0.19f</h1>
        Release: 08.07.2026

        <h2>Updates</h2>
        <ul>
            <li>Deaktive Geräte und Kunden werden in Tabellen standardmäßig ausgeblendet</li>
            <li>Ergänzen der Spalte 'StudienUID' als Auswahlmöglichkeit in Importen das Systems 'Excel'</li>
            <li>Ergänzen der Spalte 'DFP Referenz [cGy∙cm²]' als Auswahlmöglichkeit in RF-Importen das Systems 'Excel'</li>
            <li>In Tabelle 4.1 bei NM-Geräten wird der DRW nur auf MBq/kg umgerechnet, wenn das Ergebnis 2, 2.5, 3 oder 8 ist.</li>
            <li>Behebung eines Fehlers, bei welchem Excel-Mappen für Überschreitungen der letzten 20 Protokolle nicht korrekt erstellt wurden, wenn der Name länger als 31 Zeichen war.</li>
            <li>Anpassung des Verhaltens, sodass Einträge in Excelmappe "nicht zugeordnet" angezeigt werden, auch wenn keine Dosis erfasst wurde</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19e5</h1>
        Release: 12.06.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers welcher bei TQM, Guerbet und GE einzelne DRW fälschlicherweise nicht zugeordnet hat, wenn
                <ul>
                    <li>kein Alter,</li>
                    <li>kein Gewicht,</li>
                    <li>eine Studienbeschreibung mit mehr als 255 Zeihen,</li>
                    <li>ein Protokoll mit mehr als 60 Zeichen</li>
                    <li>oder eine Körperregion mit mehr als 35 Zeichen</li>
                </ul>
                angegeben ist.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19e4</h1>
        Release: 09.06.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung fehlerhafter Zählwerte in Excel-Exporten</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19e3</h1>
        Release: 28.05.2026

        <h2>Rückgängig gemacht</h2>
        <ul>
            <li>Default-Wert für "Anzahl Serien ohne Referenzwert obwohl nötig" auf 0 gesetzt.</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Default-Wert für "Anzahl Serien ohne Dosis" auf 0 gesetzt.</li>
            <li>{'Umbenennung "Anzahl Serien ohne Dosis" -> "Anzahl Serien ohne Dosis obwohl nötig"'}</li>
            <li>Anpassung der berechnung Relevanter Serien = Serien mit Referenzwert und Dosis + Serien ohne Referenzwert obwohl nötig + Serien ohne Dosis obwohl nötig</li>
            <li>Ergänzung von Spalten für Orientierungswerte in TQM Mappingdaten</li>
            <li>Ergänzung des DRW-Name in TQM Upload</li>
            <li>Behebung fehlender Rechte für die Anpassung der manuellen Mappings</li>
            <li>Behebung eines Fehlers, welcher den Upload von Mappingdateien und das Zuordnen von DRW verhindert hat</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19e2</h1>
        Release: 27.05.2026

        <h2>Neu</h2>
        <ul>
            <li>Das manuelle Mapping erlaubt nun das Mappen einer Quell-Spalte auf mehrere Ziel-Spalten.</li>
            <li>Leistungsüberwachung des Systems durch Aufzeichnung der Bearbeitungszeiten von API-Anfragen und Dateierstellungen.</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Default-Wert für "Anzahl Serien ohne Referenzwert obwohl nötig" auf 0 gesetzt.</li>
            <li>Korrektur der Formel zum Zählen der Dateneinträge, welcher zu fehlerhaften Werten geführt hat, wenn keiner Daten in der Mappe waren.</li>
            <li>Behebung eines Fehlers, welcher die Anzeige der Kontakte im Kunden verhindert hat.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19e1</h1>
        Release: 22.05.2026, 22:00 Uhr

        <h2>Updates</h2>
        <ul>
            <li>{"Die Mappe mit Überschreitungen >0% in der Excel wird nur noch erzeugt, wenn in dieser Einträge vorhanden sind."}</li>
            <li>Liste der letzten 20 Serien bei einer Überschreitung über 200% werden nur noch angezeigt, wenn die mittlere Überschreitung der 20 Serien 100% überschreitet.</li>
            <li>Bei TQM CTs werden alle Studienbeschreibungen angegeben die in den zugehörigen Serien verwendet wurden.</li>
            <li>Behebung eines Fehlers im Mapping der neuen DRW Zuordnungn.</li>
            <li>Einfügen des fehlenden "davon" im Monatsbericht NM</li>
        </ul>
        <Divider style={{marginTop: 96}}/>


        <h1>v2.0.19e</h1>
        Release: 22.05.2026, 17:30Uhr

        <h2>Neu</h2>
        <ul>
            <li>Anzeige des letzten Upload-Datum für DRW-Mappings im Tabellenkopf der DRW-Tabelle</li>
            <li>Einführung von Spaltenzuordnung und Faktor-Anpassung für den Upload von DRW-Mappings</li>
            <li>Gewichtsbasierte Aktivitätsreferenzwerte für TQM können über die Spalte "INJ [MBq/kg]" im Mapping definiert werden</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Erweiterung der DRW-Mappings um den Name des Referenzwert</li>
            <li>Flexiblere Zuordnung der DRW-Mappings über eine größere Auswahl an Spalten über welche zugeordnet werden kann</li>
            <li>Ergänzung Splatenname "Study_Comments (Studie)" in TQM</li>
            <li>Deaktivierung der Gruppierung einzelner Aufnahmen zu zusammenhängenden Untersuchungen bei XR. Jede Aufnahme erstellt jetzt eine eigene Untersuchung.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19d4</h1>
        Release: 24.04.2026

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Problems, welches die Darstellung der Appendix-Tabelle in XR Jahresberichten verhindert hat.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19d3</h1>
        Release: 16.04.2026

        <h2>Neu</h2>
        <ul>
            <li>Vorschau der Gerätenotizen in der Liste der Geräte in der Kundendetailansicht</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19d2</h1>
        Release: 15.04.2026

        <h2>Updates</h2>
        <ul>
            <li>Regex-Filter können auf jetzt auch auf Felder der Untersuchung angewendet werden</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

         <h1>v2.0.19d</h1>
        Release: 15.04.2026
        <h2>Neu</h2>
        <ul>
            <li>Anzeige der Gewichtsabhängigen DRW in den Tabellen 4.2 der Berichte für NUK.
                Sind vom System nur der absolute DRW und das Patientengewicht übermittel, wird der gewichtsabhängige DRW berechnet.</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Monats- und Jahresbericht V1 entfernt</li>
            <li>DRW-Name in Mappings ergänzt</li>
            <li>Patienten ID in Mappings ergänzt. Alle Systeme außer Excel speichern die ID standardmäßig nicht.</li>
            <li>Anpassung der Einheit in Tabelle 2d des Monatsbericht NUK</li>
            <li>Ergänzung DRW Tabelle 4.2 des Jahresberichts für alle Gerätetypen</li>
            <li>Manuelle Eingabe von Jahresdaten wurde aus dem Uploadfenster entfernt.
                Die Dateneingabe befindet sich im Prozess der Jahresberichtserstellung.</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19c2</h1>
        Release: 27.03.2026
        <h2>Neu</h2>
        <ul>
            <li>Unterstützung von partieller Übereinstimmung ("contains") im Dosis-Mapping Guerbet XR</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Ergänzung "Akquisitionsprotokoll" als Auswahlmöglichkeit im manuellen Mapping für Dose&Care XR</li>
            <li>Umstellung des Dosis-Mapping Guerbet XR von Serienbeschreibung zu Protokollname</li>
        </ul>

        <h1>v2.0.19c</h1>
        Release: 27.02.2026
        <h2>Neu</h2>
        <ul>
            <li>Import für NM für Domako-Systeme</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>{'Deaktivierung der automatische Multiplikation von Dosiswerten < 0.0009 mit 10^6 während dem Import'}</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19b1</h1>
        Release: 13.02.2026
        <h2>Updates</h2>
        <ul>
            <li>Ergänzung der Einheiten in den Tabellen der Monats- und Jahresberichte</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19b</h1>
        Release: 03.02.2026
        <h2>Updates</h2>
        <ul>
            <li>Korrektur der automatischen Berechnung der Scanlänge aus dlp und ctdi</li>
            <li>Umstellung der RF-Filter von Event auf Exam</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19a</h1>
        Release: 13.01.2026
        <h2>Updates</h2>
        <ul>
            <li>Angleichen der Jahresberichtstexte an die Monatsberichtstexte</li>
            <li>Behebung eines Fehlers wecher zur Zeitüberschreitung im Jahresbericht geführt hat</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.19</h1>
        Release: 11.01.2026

        <h2>Neu</h2>
        <ul>
            <li>Vorberechung von Formeln</li>
            <li>Neuer Schritt zur Datenvorbereitung im Ablauf der Berichterstellung</li>
            <li>Ladeanzeige beim Löschen von Uploads</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Neues Design der Login-Seite</li>
            <li>Behandlung illegaler Zeichen im Name von Excel Mappen der letzten 20 Protokolle bei 200% Überschreitungen, welche dazu führen konnten, dass die Mappen nicht korrekt erstellt wurden</li>
            <li>Behebung des Fehlers 'can't compare datetime.datetime to datetime.date', welcher stellenweise das Hochladen von Dateien verhindert hat</li>
            <li>Verbesserung des visuellen Feedbacks beim Speichern der Filtereinstellungen, insb. beim Fehlschlagen des Speicherns</li>
            <li>Verbesserung der Ladegeschwindigkeit der Uploadliste bei großen Mengen von Daten</li>
            <li>Verbesserung der Ladegeschwindigkeit der Geräteliste</li>
            <li>Stabilisierung der Zeit zur Erstellung von Excel-Exporten</li>
        </ul>
        <Divider style={{marginTop: 96}}/>


        <h1>v2.0.18e1</h1>
        Release: 19.12.2025

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers im Import</li>
        </ul>
        <Divider style={{marginTop: 96}}/>


        <h1>v2.0.18e</h1>
        Release: 18.12.2025

        <h1>Neu</h1>
        <ul>
            <li>Bearbeitbare Topogram-Filter</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers im CT Bericht bei welchem durch fehlende Dosiswerte der Textbaustein zur meldepflichtigen Grenzwertüberschreitung eingefügt wurde</li>
            <li>Ermöglichen "Serienbeschreibung" und "Protokollname" in Teamplay-Importen zu tauschen</li>
            <li>Verbesserung der Performance bei der Bestimmung der des neuesten Datensatzes pro Gerät</li>
        </ul>
        <Divider style={{marginTop: 96}}/>


        <h1>v2.0.18d2</h1>
        Release: 09.12.2025

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers im Excel-Export bei welchem die Mappe "keine Dosiswerte" nicht erstellt wurde</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.18d1</h1>
        Release: 08.12.2025

        <h2>Neu</h2>
        <ul>
            <li>{'Mappe "keine Dosiswerte" & "Alter < 16J" für alle Excel-Exporte'}</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Anpassung der Monatsberichtstexte für Untersuchungen ohne Dosis</li>
            <li>Reduktion der Dateigröße der Excel-Exporte. Die Mappen enthalten ab sofort nur noch die gefilterten Einträge</li>
        </ul>


        <h1>v2.0.18d</h1>
        Release: 28.11.2025

        <h2>Neu</h2>
        <ul>
            <li>Import für DoseM MG</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Erhöhen der Anzahl der Nachkommastellen für Dosiswerte im Excelexport auf 2</li>
            <li>DoseM unterstützt das neue Datumsformat 'DD.MM.YYYY HH:MM:SS'</li>
            <li>DoseM unterstützt Dateien bei welchen die erste Spalte komplett leer ist</li>
            <li>Anpassung des Textblock "Zuordnung Referenzwerte" im Monatsbericht</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.18c</h1>
        Release: 24.10.2025

        <h2>Updates</h2>
        <ul>
            <li>Ergänzung der Spalte "STUDY_DESCRIPTION (Studie)" in XR TQM</li>
            <li>Ergänzung der Spalte "Untersuchung Untersuchungsart" in RF DoseM</li>
            <li>Behebung eines Fehlers beim Parsen der Datumswerte, welcher den Import von XR TQM Daten verhindert</li>
            <li>Ergänzung "PatientID" als valider Patienten-ID-Name in CT Ashvins</li>
            <li>Anpassung des Textblock "systematische Überschreitungen" im Monatsbericht</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.18b</h1>
        Release: 14.10.2025

        <h2>Neu</h2>
        <ul>
            <li>Import für CT für Ashvins-Systeme</li>
            <li>Zählung von Serien ohne Dosis incl. Eingabe von manuellen Zählwerten und Textblöcken im Bericht</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers welcher den Import von Teamplay XR Daten verhindert</li>
            <li>Textanpassungen Monatsbericht: Anzahl zu Referenzwert zugeordneter Serien / Aufnahmen</li>
            <li>Entfernung "Anzahl Serien mit Überschreitung (DLP + CTDI)" in manueller Eingabe für CT</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.18a</h1>
        Release: 12.09.2025

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers welcher den Import von ClinicalPACS Daten verhindert</li>
            <li>Korrektur der Einheit von "ms" zu "s" bei Gesamt-Strahlungsdauer</li>
            <li>Anpassung der Spaltenreihenfolge im XR Excel-Export zur Korrektur der Formelverweise</li>
            <li>Behebung eines Fehlers welcher das übernehmen der Patienten ID im Excel Import verhindert</li>
            <li>Erfassung der Kommentare auf Serienebene statt Untersuchungsebene für Excel Importe</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.18</h1>
        Release: 07.09.2025

        <h2>Neu</h2>
        <ul>
            <li>Ausblenden von nicht benötigten Segmenten im Berichteditor</li>
            <li>Bearbeitbare Tabellen im Berichteditor</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Ergänzung von Spalten (DRW-Name, PatientenID, ...) in Excel-Exporten</li>
            <li>Rückgängig: Textanpassungen Monatsbericht: Anzahl zu Referenzwert zugeordneter Serien / Aufnahmen</li>
            <li>Anpassungen RF- & XR-Import ClinicalPACS: Anpassungen am Parsen von Datum und DRW-Werten</li>
            <li>Ergänzung der Unterstützung für erweiterte Kombinationen von Bedingungen im Guerbet DRW-Mapping-Upload</li>
        </ul>

        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17f1</h1>
        Release: 20.08.2025

        <h2>Update</h2>
        <li>Freischalten der Handbuchseite</li>

        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17f</h1>
        Release: 18.08.2025

        <h2>Neu</h2>
        <ul>
            <li>Import für Dose&Care XR, Angaben der "Lateralität" bzw. "Seite" werden im Mapping berücksichtigt</li>
            <li> Die Liste der Körperteil-Names des Schädels sind ab sofort in den Admin Einstellungen unter "Filter"
                anpassbar.
            </li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Name des Referenzwerts in Importmapping ergänzt, wo definiert</li>
            <li>Ergänzung "STUDY COMMENTS (Studie)" in TQM RF Import</li>
            <li>Der Verlauf der Überschreitungen im Jahresbericht wird jetzt in Prozentwerten angezeigt</li>
            <li>Textanpassungen Monatsbericht: Anzahl zu Referenzwert zugeordneter Serien / Aufnahmen</li>
            <li>Anpassung zur verbesserten Entfernung von Beispieleinträgen in Excel Importen</li>
        </ul>

        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17e</h1>
        Release: 11.07.2025

        <h2>Neu</h2>
        <ul>
            <li>Speichern der Patienten-ID in Excel-Importen</li>
            <li>Ergänzung der DRW in der Appendix-Tabelle in den Monatsberichten</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Textkorrekturen im RF-Bericht</li>
            <li>Ergänzung des Anteils bei der Anzahl von Überschreitungen Appendix-Tabelle in den Monatsberichten</li>
            <li>Verbesserung der Darstellung der Inhalte in der Appendix-Tabelle in den Monatsberichten</li>
            <li>Behebung eines Fehlers bei welchem dieselbe Studienbeschreibung wiederholt wurde</li>
            <li>Behebung eines Fehlers bei welchem Überflüssige Leerzeichen den Excel-Import behindert haben</li>
            <li>Einführung einer Warnmeldung bei fehlenden Spalten in TQM-Importen</li>
            <li>Behebung von Tippfehlern in der Spaltenzuordnung</li>
            <li>Anpassung der Spaltennamen in der Übersicht der DRW-Mappings</li>
            <li>Schlusssatz zu meldepflichtigen Ereignissen wird ausgeblendet wenn eine systematische Überschreitung
                auftritt oder die Schwelle von 80/120 mGy bzw. 20.000 cGy*cm² überschritten wurde.
            </li>
            <li>Ergänzung eines Absatzes wenn eine systematische Überschreitung auftritt</li>
            <li>Behebung eines Fehlers bei welchem zugeordnete Untersuchungen fälschlicherweise als nicht zugeordnet
                Aufgeführt wurden, wenn kein Dosiswert übermittelt wurde.
            </li>
            <li>Behebung eines Fehlers bei welchem in Dose&Care MG und TQM NM Importen kein DRW übernommen wurde</li>
            <li>Behebung eines Fehlers bei welchem in Teamplay nach dem Tauschen der Spalten kein Protokollname
                importiert wurde.
            </li>
            <li>Die Spalten 'Dosis Durchleuchtung [cGy cm²]' & 'Dosis Intervention [cGy cm²]' werden im RF Export ab
                sofort standardmäßig ausgeblendet.
            </li>
            <li>Ergänzung von 'Untersuchungsbereich DL/Intervention (Beschreibung)' in auswählbaren Spalten für
                Excel-Importe.
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17d1</h1>
        Release: 18.06.2025

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers bei welchem die Dosis für RF-Geräte nicht importiert wurde</li>
        </ul>

        <h1>v2.0.17d</h1>
        Release: 04.06.2025

        <h2>Neu</h2>
        <ul>
            <li>Import for Clinical.PACS für RF & XR</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers bei welchem die Anzahl der Untersuchungen des ersten Tages im Monat nicht korrekt
                im Bild angezeigt wurde.
            </li>
            <li>Wenn die Dosis der Durchleuchtung eines RF nicht explizit angegeben ist, wird sie aus der Summe der
                Einzeldosen der Events errechnet.
            </li>
            <li>Für DoseM CT wird die Phantomgröße basierend auf der Körperregion gesetzt. Wenn die Körperregion in
                definierten Kopfnamen ist 16 sonst 32.
            </li>
            <li>Entfernung der manuellen Eingaben für DLP in CT</li>
            <li>Entfernung der DLP Mappen im CT-Export</li>
            <li>Ergänzung von Formeln im RF-Export</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17c1</h1>
        Release: 09.05.2025

        <h2>Updates</h2>
        <ul>
            <li>Freischaltung des Monatsbericht V2 für NM</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17c</h1>
        Release: 07.05.2025
        <h2>Neu</h2>
        <ul>
            <li>Import für NM für TQM-Systeme</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers bei welchem in Teamplay Importen das Alter nicht übernommen wurde</li>
            <li>Behebung eines Fehlers bei welchem in der Auswertung der 20 vorhergehenden Serien/Untersuchungen Daten
                fremder Geräte auftauchen
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17b</h1>
        Release: 23.04.2025

        <h2>Neu</h2>
        <ul>
            <li>Anzahl meldepflichtiger Ereignisse als manuelle Eingabemöglichkeit bei CT und RF</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung von Problemen bei der Auswertung der 20 vorhergehenden Serien/Untersuchungen bei
                Überschreitungen des DRW um 200%
            </li>
            <li>Anpassungen an Formeln im Excelexport</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.17</h1>
        Release: 11.04.2025

        <h2>Neu</h2>
        <ul>
            <li>Zusätzliche Mappen zur Untersuchung der 20 vorhergehenden Serien/Untersuchungen bei Überschreitungen des
                DRW um 200% in Excel Exporten des Monatsbericht für CT und RF, wenn der DRW im Mittel um über 100%
                überschritten wird.
            </li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Erste Seite des Excel Export zeigt ab jetzt ungefilterte Daten (alles außer Topogramme)</li>
            <li>Bilder und Tabellen in RF-Berichten beziehen sich ab jetzt auf die Studienbeschreibung statt auf den
                Protokollname
            </li>
            <li>Ergänzung fehlender Namensauflösungen in manuellen Spaltenzuordnungen</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16b5</h1>
        Release: 11.04.2025
        <h2>Neu</h2>
        <ul>
            <li>Import für MG für Guerbet(Dose&Care)-Systeme</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers bei welchem Untersuchungen erhalten geblieben sind wenn ein Upload in einem RF
                Gerät gelöscht wurde.
            </li>
            <li>Ergänzung und Anpassung von Spalten im Export</li>
            <li>Anpassung der Spaltenzuordnungen in den Importen</li>
            <li>Anpassungen und Fehlerbehebungen in den Texten der Berichte</li>
            <li>Fehlerbehebungen in den Importen</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16b4</h1>
        Release: 23.02.2025

        <h2>Updates</h2>
        <ul>
            <li>Einführung bekannter aber ungenutzter Spalten in der manuellen Spalten-Zuordnung</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16b3</h1>
        Release: 14.02.2025

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung "'float' object has no attribute 'year'"</li>
            <li>Serienbezeichnunges des Kopfphantom ergänzt</li>
            <li>Fehlerbehebung fehlende Kommentare in XR GE</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16b</h1>
        Release: 07.02.2025

        <h2>Neu</h2>
        <ul>
            <li>Software 'Excel' und 'Excel Variante 2'</li>
            <li>Unterstützung mehrerer Ansprechpartner pro Gerät</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Textanpassungen an Berichten: Kein Satz mehr bei negativer max. Überschreitung, Anpassung Titel Tabelle
                d), Anzahl Kindzuordnung als Absolutwert
            </li>
            <li>Neue Kategorie "Nicht zugeordnet" im Plot der Untersuchungen pro Tag</li>
            <li>Bild a) und kurze Tabelle sind jetzt im Bericht enthalten, auch wenn keine Untersuchung zugeordnet
                wurde
            </li>
            <li>Fehlerbehebung "Eine manuelle Eingabe für diesen Monat existiert bereits" bei Jahresbericht</li>
            <li>Anpassung der Mappings</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16a</h1>
        Release: 13.12.2024

        <h2>Updates</h2>
        <ul>
            <li>Anpassung der CT Mappings für Domako, Domako3rdP, DoseM, Guerbet, Teamplay und TQM</li>
            <li>Behebung von "strptime() argument must be str" Fehler</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.16</h1>
        Release: 13.12.2024

        <h2>Neu</h2>
        <ul>
            <li>Zahlenwerte können über die Spaltenzuordnung mit einem Faktor angepasst werden</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Anpassung der GE Mappings</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.15b</h1>
        Release: 17.11.2024

        <h2>Neu</h2>
        <ul>
            <li>Unerstützung direkt übermittelter DRW für GE DOSEWATCH CT, MG und XR ohne Nutzung des manuellen
                Mappings.
            </li>
            <li>Wenn die Scanlänge nicht angegeben ist wird sie aus CTDI/DLP berechnet</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>BMI Angaben kleiner 0 werden ab sofort als ungültig ingnoriert</li>
            <li>Verbesserung des Excel-Export-Layouts durch verringerung der Zeilenhöhe, wenn die verursachende Spalte
                ausgeblendet ist.
            </li>
            <li>Anpassung der Spaltenzuordung der Körperregion für TQM RF von "BODYPART_EXAMINED (Serie)" zu
                "BODYPART_EXAMINED (Studie)"
            </li>
            <li>Aufnahmeart "Constant angle" wird ab sofort als Topogramm herrausgefiltert</li>
            <li>Körperteil "Kopf, Head, Gehirn, Brain, Paranasal Sinus, Internal Audito, Eye region, Nose,
                Nasennebenhöhle, Gesichtsschädel" werden ab sofort dem Schädel-Phantom zugeordnet
            </li>
            <li>Beschleunigungen beim Laden der Gerätedetails</li>
            <li>Behebung eines Problems bei welchem die Liste der Upload nicht mehr geladen werden konnte. Hierzu wurden
                die Details der hochgeladenen Daten aus der Uploadtabelle entfernt. Die Details sind ab sofort durch
                klicken auf den Upload-Eintrag abrufbar.
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.15</h1>
        Release: 14.09.2024

        <h2>Neu</h2>
        <ul>
            <li>Anpassbare Spaltenzuordnungen: Die Zuordnung bereits verwendeter Spalten kann für jedes Gerät
                individuell angepasst (vertauscht) werden.
            </li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Ergänzung des Zeitformates "%d.%m.%Y %H:%M" für Teamplay</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14e2</h1>
        Release: 06.09.2024

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehler, durch welchen die erste Untersuchung bei einem Re-Upload von Daten dupliziert
                wurde. Dieser Fehler kann Rückwirkend behoben werden, indem überschriebene Uploads in der
                Uploadübersicht gelöscht werden. Diese Uploads sind daran zu erkennen, dass sie nur eine oder zwei
                Untersuchungen enthalten und die Zeitspanne nur das Anfangsdatum des überschreibenden Uploads umfasst.
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14e</h1>
        Release: 11.08.2024

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehler, welcher das Anzeigen der Tabelle im RF Jahresbericht verhindert</li>
            <li>Behebung von Fehlern im TQM Import</li>
            <li>Korrektur von Schreibfehlern in den Berichten</li>
            <li>Korrektur der Achsenbeschriftung in Plots</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14d2</h1>
        Release: 10.08.2024

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehler, welcher das Anzeigen von Bildern im Browser verhindert</li>
            <li>Behebung von Fehlern durch in Bildern durch fehlende Zuordnungen</li>
            <li>Verbesserung der Ansicht der AppendixTabelle auf kleinen Bildschirmen</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14d</h1>
        Release: 09.08.2024

        <h2>Neu</h2>
        <ul>
            <li>Button zum Löschen von DRW-Mappings</li>
            <li>Automatische Auflösung der Spalte "DRW" in Mappingdaten zum richtigen DRW des Gerätetyps</li>
            <li>JahresberichtV2 für CT, MG, RF und XR</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehler, welcher das Laden der Plots im MonatsberichtV2 für RF verhindert hat</li>
            <li>Behebung des "Reindexing"-Fehlers im Import</li>
            <li>Behebung von Fehlern durch duplizierte Header am Ende der Datei in TQM</li>
            <li>Anpassungen von Textformatierungen in den Berichten</li>
            <li>Ergänzung des Hinweis zu meldepflichtigen Vorkommnissen in RF Berichten</li>
            <li>Ergänzung der Hinweise auf Überschreitungen von 20.000/50.000 cGy*cm2 in RF Berichten</li>
            <li>Entfernung des Hinweises auf Phantomüberschreitungen bei NM</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14c</h1>
        Release: 09.07.2024

        <h2>Neu</h2>
        <ul>
            <li>Monatsbericht V2 für MG, RF und XR</li>
            <li>Software "Domako (3rd Party)" und ETL hinzugefügt</li>
            <li>Warnung für Typänderung bei PET/CT ergänzt</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Textkorrektur im Monatsbericht CT für fehlende Zuordnungen</li>
            <li>Software "GE" zu "DoseWatch", "Guerbet" zu "Dose&Care" und "TQM" zu "TQM-Dose" umbenannt</li>
            <li>Topogramfilter erweitert. Gefiltert werden Protocol/Acq. Protocol = Topo|Scout|SCOUT|Planungsspirale &
                Acq. Type = Constant Angle Acquisition
            </li>
            <li>Fehlerhaft immer-leere Körperregion in RF-Excel behoben</li>
            <li>Anpassungen an Spaltennamen der TQM CT ETL. Das DRW-Mapping verweist auf Studienbeschreibung und
                Protokollname
            </li>
            <li>Anpassungen an Spaltennamen der TQM MG ETL. Das DRW-Mapping verweist auf Studienbeschreibung und
                Protokollname
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14b1</h1>
        Release: 03.07.2024

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung eines Fehlers: Beim ignorieren der "Anzahl Serien ohne DRW obwohl nötig" wurde das System
                unbenutzbar
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14b</h1>
        Release: 11.06.2024

        <h2>Updates</h2>
        <ul>
            <li>Formelkorrekturen in RF Exporten</li>
            <li>"CT Aufnahmeart" in CT-Exporten eingeblendet</li>
            <li>Gruppe "Nicht zugeordnet" auf der x-Achse der Plots im Monatsbericht V2 ergänzt</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.14</h1>
        Release: 09.06.2024
        <h2>Neu</h2>
        <ul>
            <li>Daten importe für TQM und GE für CT, MG und XR, sowie Mappingdaten</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Ergänzung eines neuen Spaltennamen für Teamplay-CT-Importe</li>
            <li>Ergänzung fehlender Formeln im Excel-Export</li>
            <li>Umbenennung "Acc.DFP" zu "DFP" in RF-Export</li>
        </ul>
        <h3>Formelanpassungen</h3>
        <ul>
            <li>Ergänzung eines fixen Filters für Topogramme, angewendet auf alle Formeln. Anpassung des existierenden
                Filters auf Monitorings
            </li>
            <li>Umbenennung der "relevanten Serien" zu "Serien mit DRW"</li>
            <li>Berechnung der relevanten Serien aus der Summe der Serien mit DRW und den Serien ohne DRW obwohl nötig
            </li>
            <li>Anpassung von Anteilswerten auf die neue Formel relevanter Serien</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.13b</h1>
        Release: 09.06.2024

        <h2>Updates</h2>
        <ul>
            <li>Korrektur der Platzierung der Signatur</li>
            <li>Textanpassungen in Monatsberichten</li>
            <li>Formatierungsanpassungen in Monatsberichten</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.13</h1>
        Release: 01.05.2024

        <h2>Neu</h2>
        <ul>
            <li>Max. CTDI für Kopf und Körper Serien bei CT</li>
            <li>Die Appendix-Tabelle im CT Monatsbericht V2 wurde um weitere statistische Werte ergänzt</li>
            <li>Der Excel-Export für Jahresberichte erfolgt aus Performance-Gründen nur noch auf Anforderung</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Korrektur von Schreibfehlern</li>
            <li>Textanpassungen in Monatsberichten</li>
            <li>Formatierungsanpassungen in Monatsberichten</li>
            <li>Anpassung Achsenbeschriftung in CT Monatsbericht V2</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12f</h1>
        Release: 13.04.2024

        <h2>Neu</h2>
        <ul>
            <li>Im Jahresbericht ist ab sofort eine Vorschau verfügbar</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Die Übersichtstabelle in Jahresberichten hat keine Spalte für Vorjahreswerte mehr, wenn dort keine Daten
                existieren
            </li>
            <li>Die Boxplots in Monatsberichten wird nur angehängt, wenn Grafiken mit Boxplot enthalten sind</li>
            <li>Fehlerbehebung in ETL XR Teamplay</li>
            <li>Fehlerbehebung in ETL CT+MG Guerbet</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12e</h1>
        Release: 07.03.2024

        <h2>Neu</h2>
        <ul>
            <li>Der Monatsbericht V2 enthält ab sofort die Erklärung für Boxplots auf der letzten Seite</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12d</h1>
        Release: 24.02.2024

        <h2>Updates</h2>
        <ul>
            <li>Manuelle Eingaben werden in der Anhang-Tabele des Monatsberichts ignoriert, da diese nicht einzelnen
                Protokollen zugeordnet werden können.
            </li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12c</h1>
        Release: 22.02.2024

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung in der Datenverarbeitung für Guerbet CT und MG, DoseM RF und XR</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12b</h1>
        Release: 15.02.2024

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung MG-Import</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.12</h1>
        Release: 11.02.2024

        <h2>Neu</h2>
        <ul>
            <li>Neue Felder in der Datenbank und im Datenimport ergänzt</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Datenimport stabilisiert: Fehlerhafte Werte im Datenimport führen nicht mehr zum Abbruch des Imports.
                Fehlerhafte Werte werden übersprungen und eine Warnung wird im Datensatz gespeichert.
                Zusätzlich wird eine Warnung in der App angezeigt.
            </li>
            <li>Fehlermeldungen verkürzt und verständlicher gemacht</li>
            <li>Spaltennamen im Export auf Deutsch geändert</li>

            <li>Probleme beim Ablegen der Dateien im Uploadfenster behoben</li>
            <li>Fehler bei der Verwendung von Unterstrichen im Monatsbericht bzw. in Aliasnamen behoben</li>

            <li>Probleme in den Tabellen der Monatsberichte durch leere Protokolle behoben</li>
            <li>Stabilisierung der Monatsberichte: Bei fehlerhaften Bildern oder Tabellen kann das PDF jetzt ohne
                diese Inhalte erzeugt werden.
            </li>
            <li>Anzahl der Protokolle und BodyRegions in den Bildern der Monatsberichte auf 20 begrenzt</li>
        </ul>
        <Divider style={{marginTop: 96}}/>

        <h1>v2.0.11b</h1>
        Release: 12.01.2024

        <h2>Updates</h2>
        <ul>
            <li>Korrektur fehlerhafter Formeln im Excelexport</li>
            <li>Korrektur fehlerhafter y-Achsen-Werte in Grafiken des Monatsberichts</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.11a</h1>
        Release: 12.01.2024

        <h2>Updates</h2>
        <ul>
            <li>Behebung eines Fehlers welcher den Excelexport von RF Daten verhindert hat</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.11</h1>
        Release: 07.01.2024

        <h2>Neu</h2>
        <ul>
            <li>neuer Monatsbericht mit Grafiken und Tabellen für CT</li>
            <li>der neue Monatsbericht enthält Kontaktdaten des MPE, wenn diese im Nutzeraccount des MPE hinterlegt
                sind
            </li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Die gewohnten Monatsberichte für alle Gerätetypen sind unter "Monatsbericht V1" zu finden</li>
            <li>Maximaler CTDI in CT Monatsbericht ergänzt</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.10d</h1>
        Release: 19.11.2023

        <h2>Neu</h2>
        <ul>
            <li>{"Tabellenblatt für 'Gesamtdosis > 20000/50000 cGy cm2' im Excelexport für RF ergänzt"}</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung zu fehlenden Kommentaren bei DoseM importen</li>
            <li>Quick-Action Buttons wurden nach links verschoben</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.10c</h1>
        Release: 04.11.2023

        <h2>Neu</h2>
        <ul>
            <li>Unterstützung von DoseM XR im Upload</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Maximaler CTDI in CT Monatsbericht ergänzt</li>
            <li>Ergänzung von "Durchleuchtung" bzw. "Intervention" im RF Monatsbericht</li>
            <li>Fehlerbehebung in der Klassifizierungen des Patient als Erwachsener</li>
            <li>{"Fehlerbehebung im CT Excelexport für CTDI > 80/120 mGy"}</li>
            <li>Fehlerbehebung bei der automatischen Encoding-Erkennung</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.10b</h1>
        Release: 29.09.2023

        <ul>
            <li>Update des Jahresbericht auf neue Formeln und erweiterte Excel-Exporte</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.10a</h1>
        Release: 28.09.2023

        <h2>Updates</h2>
        <ul>
            <li>Behebung von Problemen bei welchen die Kommentierungsquote in den Berichten fehlt wenn nur manuelle
                Eingaben vorliegen.
            </li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.10</h1>
        Release: 24.09.2023

        <h2>Neu</h2>
        <ul>
            <li>Neuer Workflow für Berichte: Ein extra Schritt ermöglicht das Editieren der Werte über eine manuelle
                Eingabe
            </li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Der maximale Referenzwert wird jetzt für jeden Gerätetyp im Bericht erwähnt</li>
            <li>Überschreitungen der Meldeschwelle 20000/50000 cGy*cm² im RF-Bericht ergänzt</li>
            <li>{'Korrekturen an der Klassifizierung falscher Kindzuordnungen: Die Grenze für Kinder ist jetzt < 180 Monate und < 56kg'}</li>
        </ul>

        <h2>Bekannte Bugs</h2>
        Die folgenden Probleme sind bekannt, an einer Lösung wird gearbeitet:
        <ul>
            <li>Unterschriche in Geräte Namen oder Aliassen führen zu Formatierungsfehlern in Berichten. Dieses Problem
                kann umgangen werden, indem keine Unterstriche verwendet werden.
            </li>
            <li>Die Erzeugung von Jahresberichten funktioniert abhängig vom Gerätetyp nur eingeschränkt oder garnicht.
            </li>
        </ul>


        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.9d</h1>
        Release: 11.09.2023

        <h2>Updates</h2>
        <ul>
            <li>Fehlerbehebung Export PET/CT</li>
        </ul>


        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.9c</h1>
        Release: 03.09.2023

        <h2>Updates</h2>
        <ul>
            <li>Erstellungsdatum in Berichten ergänzt</li>
            <li>Fehlerbehebung welcher das System bei leerem CTDI unnutzbar macht</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.9b</h1>
        Release: 10.08.2023

        <h2>Updates</h2>
        <ul>
            <li>{'Fehlerkorrektur in Berechnung von RF Sereien mit DFP > 20.000/50.000 cGy*cm2'}</li>
            <li>Import der Scanlänge bei Domako CTs</li>
            <li>Kinder- & Phantomzuordnungen in Excel ausgeblendet wenn nicht benötigt</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.9</h1>
        Release: 09.08.2023

        <h2>Neu</h2>
        <ul>
            <li>Rechtschreibprüfung durch lokalen LanguageTool-Server</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Dosismanagementsysteme "Dose&Care" und "RadCentre" hinzugefügt</li>
            <li>PET zu PET/CT umbenannt</li>
            <li>Überschreitungen DFP Grenzwerts von 20000 und 50000 in manuellen Eingaben ergänzt</li>
            <li>{'CT Excelexport enthält ab jetzt Monitoringserien in den Mappen "CTDI>80mGy" und "CTDI>120mGy"'}</li>
            <li>Instituts- und Geräteinfo in Excel ergänzt</li>
            <li>Support Mail auf support@itp-consult.de aktualisert</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.8b</h1>
        Release: 18.07.2023

        <h2>Updates</h2>
        <ul>
            <li>Bugfixes zur Stabilisierung des Systems</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.8</h1>
        Release: 17.07.2023
        <h2>Neu</h2>
        <ul>
            <li>RF-Formeln auf Untersuchungsebene umgestellt</li>
            <li>RF-Excelexport auf Untersuchungsebene umgestellt</li>
            <li>Formelberechnungen überarbeitet</li>
            <li>Manuelle Eingaben überschreiben berechnete Werte partiell, dort wo manuelle Eingaben gemacht wurden</li>
            <li>'Max. Überschreitung' zu manuellen Eingaben hinzugefügt</li>
            <li>Warnung im Tabellen-Footer wenn Filter gesetzt sind</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Messwert 'INJ' zu 'Aktivität' umbenannt</li>
            <li>Serientab in den Gerätedetails ausgeblendet</li>
            <li>Pflichtfelder in manuellen Eingaben entfernt</li>
            <li>Monatsberichte auf ganze Monate eingegrenzt</li>
            <li>Quickaction-Buttons am rechten Tabellenrand fixiert</li>
            <li>Tabs für falsche Kind- & Phantomzuordnung im Excelexport hinzugefügt</li>
            <li>Institution und Gerätename im Export hinzugefügt</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.7b</h1>
        Release: 12.06.2023
        <h2>Update</h2>
        <ul>
            <li>Fehler in der BMI Berechnung bei Größe = 0 abgefangen</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.7</h1>
        Release: 24.05.2023
        <h2>Neu</h2>
        <ul>
            <li>Button für Seitenumbruch im Editor</li>
        </ul>

        <h2>Updates</h2>
        <ul>
            <li>Behebung fehlender Überschreitungen bei XR und RF bei automatischem Upload</li>
            <li>Patienten sind ab dem 17 Lebensjahr als Erwachsen zu werten</li>
            <li>Teamplay und Domako Upload mit mehr als 6 Millisekundenstellen unterstützt</li>
            <li>Fehlende Werte durch Anzeigefehler in den Uploadtabellen angepast</li>
            <li>DLP-Überschreitungen werden nicht mehr für die Kommentierungsquote beachtet</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.6</h1>
        Release: 11.05.2023
        <h2>Updates</h2>
        <ul>
            <li>Fehler im Domakoimport behoben</li>
            <li>Fehlende Berechtigung zum Löschen von Uploads angepasst</li>
            <li>Fehler im PDF Export behoben ("~"-Zeichen in Leerzeilen)</li>
            <li>Breadcrumbs angepasst</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.5</h1>
        Release: 04.05.2023
        <h2>Updates</h2>
        <ul>
            <li>Kommentare für Domako Uploads werden wieder nur aus Spalte "Kommentare von Benutzern" übernommen</li>
            <li>Probleme beim Import von Kommentaren für Domako Upload wurden behoben</li>
            <li>Geänderte Datumsformate in Teamplay werden unterstützt</li>
            <li>Formatierungsfelher in Latex bei verwendung von Anführungszeichen wurden behoben</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.4</h1>
        Release: 22.04.2023
        <h2>Updates</h2>
        <ul>
            <li>Kommentare für Domako Uploads werden jetzt aus Spalte "Kommentar" und "Kommentare von Benutzern"
                übernommen und zusammengefügt
            </li>
            <li>Die Berechnung der Anzahl der Überschreitungen der absoluten CTDI Meldeschwellen wurde korrigiert</li>
            <li>Das neue Datumsformat für die StudyTime für Teamplay NM wird unterstützt</li>
            <li>Der Text zu fehlerhaften Phantomzuordnungen wurde aus den RF Berichten entfernt</li>
            <li>Anpassung der Dateinamen für Berichte und Excel-Exporte</li>
            <li>Der BreadCrumb in der Gerätedetailansicht verweist jetzt auf den Kunden</li>
            <li>Die Anzahl der Nachkommastellen im Verlauf der Monatsberichtswerte ist an die Definition der Berichte
                angeglichen
            </li>
            <li>Fehlermeldungen über den "Bug melden"-Button werden standardmäßig im CC an den MPE-Mailverteiler
                gesendet
            </li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.3</h1>
        Release: 12.04.2023
        <h2>Updates</h2>
        <ul>
            <li>Korrektur der Einordnung der CTDI Überschreitung im Monatsbericht</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.2</h1>
        Release: 07.04.2023
        <h2>Neu</h2>
        <ul>
            <li>Upload-Liste enthält jetzt auch automatische Uploads</li>
            <li>Upload für DoseM RF</li>
        </ul>
        <h2>Updates</h2>
        <ul>
            <li>Neuer Text der Monatsberichte für MG, NM, PET, RF, XR</li>
            <li>Aktualisierter Text des Monatsberichtes für CT</li>
            <li>Anpassungen am Reportdesign</li>
            <li>Anpassungen an Dateibenamungen für Exporte</li>
            <li>Verbesserungen im manuellen Import</li>
            <li>Suchfunktion in Bearbeitungsansicht beachtet keine Groß- und Kleinschreibung</li>
            <li>Gerätelisten zeigen die vollständige Adresse</li>
            <li>Domako Uploads unterstützen UTF-8 & CP1252 Format</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.1</h1>
        Release: 23.03.2023
        <h2>Neu</h2>
        <ul>
            <li>Monatsberichte als PDF</li>
        </ul>
        <h2>Updates</h2>
        <ul>
            <li>Neuer Text für CT-Monatsberichte</li>
            <li>Verbesserungen im manuellen Import</li>
            <li>Aktivitäts-Popups nach unten links verschoben</li>
            <li>Filter der Geräteliste in den Kundendetails werden nicht mehr gespeichert</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.0 - GoLive</h1>
        Release: 08.03.2023
        <h2>Neu</h2>
        <ul>
            <li>Datenimport Teamplay: RF, NUK, PET-CT</li>
            <li>Datenimport Domako: RF</li>
            <li>Einführung der Referenzwerte für ScanLength für CT</li>
            <li>Korrekturen im manuellen Upload</li>
        </ul>
        <h2>Updates</h2>
        <ul>
            <li>Korrekturen in den Datenimporten</li>
            <li>Optimierung der Jahresberichtserzeugung</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.beta2</h1>
        Release: 12.02.2023
        <h2>Neu</h2>
        <ul>
            <li>Layout-Update</li>
            <li>PDF-Jahresbericht mit Editor</li>
            <li>Manueller Upload für das gesamte Jahr möglich</li>
            <li>vCard-Import für Kontakte</li>
            <li>DoseM ist als Sorfware im System verfügbar</li>
            <li>Zusätzliche Seiten im Excel-Export mit Auswertungen</li>
            <li>Formeln mit Auswertungen im Excel Export</li>
            <li>Verlaufsübersicht der letzten 12 Monate im Gerät hinzugefügt</li>
        </ul>

        <Divider style={{marginTop: 96}}/>
        <h1>v2.0.beta1</h1>
        Release: 28.11.2022
        <h2>Neu</h2>
        <ul>
            <li>Monatsbericht</li>
            <li>Datenimport für Teamplay & Domako</li>
            <li>Manuelle Eingaben</li>
        </ul>
    </>
)
